class PredictiveSearch extends SearchForm {
  constructor() {
    super();
    this.cachedResults = {};
    this.predictiveSearchResults = this.querySelector('[data-predictive-search]');
    this.allPredictiveSearchInstances = document.querySelectorAll('predictive-search');
    this.isOpen = false;
    this.abortController = new AbortController();
    this.hasSearched = false;
    this.loading = false;

    this.setupEventListeners();
  }

  setupEventListeners() {
    if (this.input && this.input.form) {
      this.input.form.addEventListener('submit', this.onFormSubmit.bind(this));
    }

    if (this.input) {
      this.input.addEventListener('focus', this.onFocus.bind(this));
      this.input.addEventListener('keyup', this.onKeyup.bind(this));
      this.input.addEventListener('keydown', this.onKeydown.bind(this));
    }
    
    this.addEventListener('focusout', this.onFocusOut.bind(this));
  }

  onChange(event) {
    super.onChange(event);
    const newSearchTerm = this.getQuery();
    if (newSearchTerm.length > 0) {
      this.getSearchResults(newSearchTerm);
    } else {
      this.clearResults();
    }
  }

  onFocus() {
    this.isOpen = true;
    const searchTerm = this.getQuery();
    if (searchTerm.length > 0) {
      this.getSearchResults(searchTerm);
    }
  }

  onFocusOut(event) {
    // Don't close if clicking within the predictive search results
    if (this.contains(event.relatedTarget)) {
      return;
    }
    this.isOpen = false;
  }

  onKeydown(event) {
    // Handle arrow keys and enter for navigation
    switch (event.code) {
      case "ArrowUp":
      case "ArrowDown":
        // Navigation logic can be added here
        break;
      case "Enter":
        // Let form submit naturally
        break;
      case "Escape":
        event.preventDefault();
        this.dispatchEvent(new CustomEvent('toggle-search'));
        break;
    }
  }

  onKeyup(event) {
    switch (event.code) {
      case "ArrowUp":
      case "ArrowDown":
      case "Enter":
      case "Escape":
        // Handled in onKeydown
        break;
      default:
        const newSearchTerm = this.getQuery();
        if (newSearchTerm.length > 0) {
          this.getSearchResults(newSearchTerm);
        } else {
          this.clearResults();
        }
        break;
    }
  }

  onFormSubmit(event) {
    // Allow form to submit normally
  }

  getQuery() {
    return this.input ? this.input.value.trim() : '';
  }

  getSearchResults(searchTerm) {
    if (!searchTerm || searchTerm.length === 0) {
      return;
    }

    const queryKey = searchTerm.replace(/\s+/g, "-").toLowerCase();

    if (this.cachedResults[queryKey]) {
      this.renderSearchResults(this.cachedResults[queryKey]);
      return;
    }

    // Abort previous request
    this.abortController.abort();
    this.abortController = new AbortController();

    this.setLoading(true);

    if (!window.routes || !window.routes.predictive_search_url) {
      console.error('Predictive search URL not available');
      return;
    }

    fetch(
      `${window.routes.predictive_search_url}?q=${encodeURIComponent(
        searchTerm
      )}&section_id=predictive-search&resources[options][fields]=title,product_type,variants.title,tag`,
      {
        signal: this.abortController.signal,
      }
    )
      .then((response) => {
        if (!response.ok) {
          var error = new Error(response.status);
          throw error;
        }

        return response.text();
      })
      .then((text) => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(text, "text/html");
        const section = doc.querySelector("#shopify-section-predictive-search");
        
        if (!section) {
          throw new Error('Predictive search section not found');
        }

        const resultsMarkup = section.innerHTML;
        
        // Cache the results
        this.cachedResults[queryKey] = resultsMarkup;
        
        // Sync cache across all instances
        this.allPredictiveSearchInstances.forEach((instance) => {
          if (instance !== this && instance.cachedResults) {
            instance.cachedResults[queryKey] = resultsMarkup;
          }
        });

        this.renderSearchResults(resultsMarkup);
        this.setLoading(false);
      })
      .catch((error) => {
        if (error?.code === 20 || error.name === 'AbortError') {
          // Request was aborted, ignore
          return;
        }
        console.error('Predictive search error:', error);
        this.setLoading(false);
      });
  }

  setLoading(loading) {
    this.loading = loading;
    if (loading) {
      this.setAttribute('loading', '');
    } else {
      this.removeAttribute('loading');
    }
  }

  clearResults() {
    if (this.predictiveSearchResults) {
      this.predictiveSearchResults.innerHTML = '';
    }
    this.hasSearched = false;
  }

  renderSearchResults(resultsMarkup) {
    this.hasSearched = true;

    if (this.predictiveSearchResults) {
      this.predictiveSearchResults.innerHTML = resultsMarkup;
    }
  }

  clearResults() {
    if (this.predictiveSearchResults) {
      this.predictiveSearchResults.innerHTML = '';
    }
    this.hasSearched = false;
  }
}

customElements.define('predictive-search', PredictiveSearch);
